import { RequestBasePageId, RequestBaseSet } from "@myapp/modules/fwcore/models/messages/request-base";
import { ResponseBase, ResponseBasePage, ResponseBaseSet } from "@myapp/modules/fwcore/models/messages/response-base";
import { UserState } from "../user-state";

export class RequestUserState extends RequestBasePageId {

  companyId?: string | null;
  licenseId?: string | null;
  assigned?: boolean | null;
  active?: boolean | null;
  startsWith?: string | null;
  startsWithDepth?: string | null;

}

export class RequestUserStateSet extends RequestBaseSet<UserState>
{
}

export class ResponseUserState extends ResponseBasePage<UserState> {

}


export class ResponseUserStateSet extends ResponseBaseSet<UserState>{

}

export class RequestUserAccessEmailSet extends RequestBaseSet<string> {
  licenseId?: string | null;
  emailAddresses?: string[] | null;
  templateContentOktaExists?: string | null;
  templateContentOktaNotExists?: string | null;
  logoRawBase64?: string | null;
  logoHeight?: number | null;
}

export class ResponseUserAccessEmailSet extends ResponseBase {

  emailTotal?: number | null;
  emailSuccess?: number | null;
  emailFailure?: number | null;

}

export class RequestModuleUserSet {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  licenseId?: string | null;
  data?: string[] | null;
  userProfileEmail?: string | null;
  companyId?: string | null;
}
